import * as React from 'react'

import { Button } from 'tabler-react'



interface Props {
  isLogged:boolean
  isApplied:boolean
  applyToJob:Function
  openApplyModal:Function
  openLogin:Function
  openRegister:Function
}

class JobDetailsCTA extends React.Component<Props> {
  render () {
    const {
      isLogged,
      isApplied,
      applyToJob,
      openApplyModal,
      openRegister,
      openLogin
    } = this.props

    return (
      <Button.List>
         {
           isLogged ?
          <React.Fragment>
            {
                isApplied ? <Button color="success" icon='check'>Applied</Button> : <Button color="primary" onClick={applyToJob}>Apply</Button>
            }
          </React.Fragment> :
          <React.Fragment>
            <Button color="blue" onClick={openLogin}>
              Login to apply
            </Button>
            <Button color='blue' onClick={openRegister}>
              Register to apply
            </Button>
            <Button link onClick={openApplyModal}>
              Apply without Registration
            </Button>
          </React.Fragment>
        }
      </Button.List>
    )
  }
}

export default JobDetailsCTA